import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const testimonials = [{
    quote: t('test.1.quote'),
    author: t('test.1.author')
  }, {
    quote: t('test.2.quote'),
    author: t('test.2.author')
  }, {
    quote: t('test.3.quote'),
    author: t('test.3.author')
  }];
  return <section id="testimonials" className="py-24 lg:py-[160px] px-8 lg:px-[60px] bg-[#020202] border-t border-white/[0.02] overflow-hidden" data-id="element-251">
      <div className="max-w-[1400px] mx-auto" data-id="element-252">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1.2,
        ease: [0.16, 1, 0.3, 1]
      }} className="mb-20 lg:mb-24" data-id="element-253">
          <p className="font-sans text-[10px] tracking-[6px] uppercase text-crimson-glow font-medium mb-6 flex items-center gap-5 before:content-[''] before:w-[40px] before:h-px before:bg-gradient-to-r before:from-crimson-glow before:to-transparent opacity-90" data-id="element-254">
            {t('test.label')}
          </p>
          <h2 className="font-serif text-[36px] sm:text-[44px] lg:text-[64px] font-medium leading-[1.05] tracking-[-0.02em] text-white" data-id="element-255">
            {t('test.headline')}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-256">
          {testimonials.map((test, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 1.2,
          ease: [0.16, 1, 0.3, 1],
          delay: i * 0.15
        }} className="p-10 lg:p-[64px_48px] bg-[#050505] border border-white/[0.03] relative transition-all duration-500 hover:border-white/[0.08] hover:bg-[#080808] group" data-id="element-257">
              <div className="absolute top-12 right-12 flex gap-[4px] opacity-60 group-hover:opacity-100 transition-opacity duration-500" data-id="element-258">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-3 h-3 text-gold-light fill-gold-light" data-id="element-259" />)}
              </div>

              <span className="font-serif text-[100px] lg:text-[140px] text-white/[0.03] leading-[0.6] mb-8 block group-hover:text-crimson/[0.05] transition-colors duration-500" data-id="element-260">
                "
              </span>

              <p className="font-serif text-[20px] lg:text-[22px] leading-[1.8] text-white/70 italic font-light mb-12 group-hover:text-white/90 transition-colors duration-500" data-id="element-261">
                {test.quote}
              </p>

              <div className="w-12 h-px bg-gradient-to-r from-crimson to-transparent mb-6" data-id="element-262"></div>

              <span className="font-sans text-[10px] tracking-[4px] uppercase text-white/40 font-medium" data-id="element-263">
                — {test.author}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}